import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import { StoreProps } from '../../../../services/stores/casting.store'
import { useTheme } from 'styled-components'

const i18nScoped = new I18nService(require('./complex-variant-form.component.yml'))

export default function ComplexVariantFormComponent ({ data: { castingType, complexVariantMonoSlotMultiAllowedPatterns }, store }: StoreProps) {
  const theme = useTheme()

  const buildChoiceProps = React.useCallback((value: boolean): React.HTMLAttributes<HTMLDivElement> => {
    const active = complexVariantMonoSlotMultiAllowedPatterns === value 
    const backgroundColor = active ? theme.colors.clr_1 : undefined
    const color = active ? 'white' : undefined

    return {
      id: `js-test-complex-variant-${value ? 'mono-slot' : 'multi-slots'}`,
      className: `boxPod ${active ? 'active' : ''}`, 
      style: { margin: '0.5em', padding: '1em', cursor: 'pointer', backgroundColor, color },
      onClick: () => {
        store.set({ complexVariantMonoSlotMultiAllowedPatterns: value })
        store.nextFocus()
      }
    }
  }, [complexVariantMonoSlotMultiAllowedPatterns, store, theme.colors.clr_1])

  return <React.Fragment>
    <div { ...buildChoiceProps(false) }>
      <p className='form-label u-mtn'>
        <em className='icon-long-arrow-right u-mrs' /> { i18nScoped.t(`multiple_slots_one_allowed_patterns.title_${castingType}`) }
      </p>

      <p>{ i18nScoped.t('multiple_slots_one_allowed_patterns.description') }</p>
    </div>

    <div { ...buildChoiceProps(true) }>
      <p className='form-label u-mtn'>
        <em className='icon-long-arrow-right u-mrs' /> { i18nScoped.t(`one_slot_multiple_allowed_patterns.title_${castingType}`) }
      </p>

      <p>{ i18nScoped.t('one_slot_multiple_allowed_patterns.description') }</p>
    </div>
  </React.Fragment>
}
